import Image, { ImageProps } from 'next/image';

interface Props extends ImageProps {
  alt: string;
  width?: string | number;
  height?: string | number;
  plp?: boolean | undefined;
  src: any;
}

function OwnImage({ alt, width, height, src, plp = false, ...rest }: Props) {

  return (
    <Image
      {...rest}
      src={src ? src : plp ? '/images/default-image.jpg':'https://cdn.kilid.com/default-logo.png'}
      width={width}
      height={height}
      alt={alt}
      layout={rest.layout || 'responsive'}
      placeholder="blur"
      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcvgAAAfQBSWu8iX0AAAAASUVORK5CYII="
      onError={(err) => {
        err.currentTarget.src = plp ? '/images/default-image.jpg':'https://cdn.kilid.com/default-logo.png';
        err.currentTarget.srcset = '';
      }}
    />
  );
}

export default OwnImage;
